namespace TabAurous.OMS {
    export interface AdditionalChargesForm {
        ApplicableOn: Serenity.EnumEditor;
        AdditionalChargeCode: Serenity.StringEditor;
        AdditionalChargeName: Serenity.StringEditor;
        RateType: Serenity.EnumEditor;
        Rate: Serenity.DecimalEditor;
        TransactionCalculateOn: Serenity.RadioButtonEditor;
        ProductCalculateOn: Serenity.RadioButtonEditor;
        IncludeTax: Serenity.BooleanEditor;
        ExcludeDiscount: Serenity.BooleanEditor;
        Vouchers: Serenity.LookupEditor;
        Narration: Serenity.StringEditor;
    }

    export class AdditionalChargesForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.AdditionalCharges';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AdditionalChargesForm.init)  {
                AdditionalChargesForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.LookupEditor;

                Q.initFormType(AdditionalChargesForm, [
                    'ApplicableOn', w0,
                    'AdditionalChargeCode', w1,
                    'AdditionalChargeName', w1,
                    'RateType', w0,
                    'Rate', w2,
                    'TransactionCalculateOn', w3,
                    'ProductCalculateOn', w3,
                    'IncludeTax', w4,
                    'ExcludeDiscount', w4,
                    'Vouchers', w5,
                    'Narration', w1
                ]);
            }
        }
    }
}
